/** @format */

const template = `
<div class="calendar-settings-modal">
  <div class="modal-header">
    <h2 class="modal-title" translate="CALENDAR_SETTINGS.TAKE_TO_OWN"></h2>
    <button type="button" class="modal-close" ng-click="ctrl.dismiss()" aria-label="{{'ARIA_LABEL.CLOSE' | translate}}">
      <sis-icon icon="ring-close"></sis-icon>
    </button>
  </div>

  <div class="modal-body">
    <div class="row">
      <div class="col-12">
        <div class="content" translate="CALENDAR_SETTINGS.EXPORT_INFO"></div>
      </div>
    </div>
    <div class="calendar-settings-link">
      <!-- Get token from /api/calendar-share-tokens and set it to value -->
      <input
        ng-if="ctrl.token !== undefined"
        id="calendarSettingsLink"
        class="form-control"
        name="calendarSettingsLink"
        value="{{ctrl.token}}"
        readonly />
      <sis-tooltip
        tooltip-text="{{'CALENDAR_SETTINGS.COPIED_TO_CLIPBOARD' | translate }}"
        tooltip-placement="bottom"
        [append-to-body]="true"
        [tooltip-block-element]="true"
        tooltip-triggers="click:mouseleave">
        <button
          type="button"
          class="btn btn-primary btn-hollow btn-sm sis-tooltip-trigger-content"
          ngclipboard
          ngclipboard-success="ctrl.onSuccess(e);"
          ngclipboard-error="ctrl.onError(e);"
          data-clipboard-action="copy"
          data-clipboard-target="#calendarSettingsLink">
          <span translate="CALENDAR_SETTINGS.COPY_TO_CLIPBOARD"></span>
        </button>
      </sis-tooltip>
    </div>
  </div>
</div>
`;
export default template;
